import { ShieldAlert } from 'lucide-react';

export const SecurityBanner = ({ variant = 'default', className = '' }) => {
  if (variant === 'compact') {
    return (
      <div
        data-testid="security-banner"
        className={`flex items-center gap-2 bg-[#FFF6C7] border border-[#F7D618]/60 text-[#7A5F00] rounded-[var(--radius)] px-3 py-2 text-sm ${className}`}
      >
        <ShieldAlert size={16} className="flex-shrink-0" />
        <span className="font-medium">Tous les paiements passent par Job Kongo. Ne payez jamais en dehors.</span>
      </div>
    );
  }
  return (
    <div
      data-testid="security-banner"
      className={`flex items-start gap-3 bg-[#FFF6C7] border border-[#F7D618]/60 text-[#5C4600] rounded-[var(--radius)] px-4 py-3 ${className}`}
    >
      <ShieldAlert size={20} className="flex-shrink-0 text-[#7A5F00] mt-0.5" />
      <div className="text-sm">
        <p className="font-semibold">Pour votre sécurité, payez uniquement via Job Kongo.</p>
        <p className="text-[#5C4600]/90 mt-0.5">Paiement en dehors = exclusion définitive, perte d&apos;assurance et d&apos;assistance.</p>
      </div>
    </div>
  );
};
